import { Component, input } from '@angular/core';
import type { FieldTree } from '@angular/forms/signals';
import { FormField, FormRoot } from '@angular/forms/signals';
import { TranslocoPipe } from '@jsverse/transloco';
import { HlmFieldImports } from '@mb/ui/field';
import { HlmInputImports } from '@mb/ui/input';
import type { PersonFormDto } from '../../shared';

@Component({
  selector: 'app-contact-form',
  standalone: true,
  templateUrl: './contact-form.component.html',

  imports: [
    FormField,
    FormRoot,
    HlmFieldImports,
    HlmInputImports,
    TranslocoPipe,
  ],
})
export class ContactFormComponent {
  form = input.required<FieldTree<PersonFormDto>>();

  titleOptions = [
    { value: '', label: 'contacts.form.placeholders.title' },
    { value: 'Dr.', label: 'Dr.' },
    { value: 'Prof.', label: 'Prof.' },
    { value: 'Mr.', label: 'Mr.' },
    { value: 'Ms.', label: 'Ms.' },
    { value: 'Mrs.', label: 'Mrs.' },
  ];

  typeOptions = [
    { value: 'employee', label: 'contacts.types.employee' },
    { value: 'contractor', label: 'contacts.types.contractor' },
  ];

  tagOptions = [{ value: 'host', label: 'contacts.tags.host' }];

  toggleTag(tag: string): void {
    const current = this.form().tags().value() ?? '';
    const parts = current
      .split(',')
      .map((t) => t.trim())
      .filter(Boolean);
    const has = parts.includes(tag);
    const next = has ? parts.filter((t) => t !== tag) : [...parts, tag];
    this.form().tags().value.set(next.join(','));
  }

  hasTag(tag: string): boolean {
    const current = this.form().tags().value() ?? '';
    return current
      .split(',')
      .map((t) => t.trim())
      .filter(Boolean)
      .includes(tag);
  }
}
